import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import FlatButton from 'material-ui/FlatButton'
import AddIcon from 'material-ui/svg-icons/content/add-box'

import { push as pushAction } from 'react-router-redux'
import { showNotification as showNotificationAction } from 'admin-on-rest'

import constants from '../utils/constants'

const style = {
  color: 'green',
  width: 20
}

class CreateMoneyButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false,
      value: null
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleOpen () {
    this.setState({open: true})
  };

  handleClose () {
    this.setState({open: false})
  };

  handleClick () {
    const { value } = this.state
    const { record, showNotification } = this.props

    if (!Number(value)) {
      return showNotification('Verifique o valor!', 'warning')
    }

    const url = `${constants.apiUrl}/moneyTransfer`
    const options = {
      method: 'POST',
      body: JSON.stringify({
        value,
        _gasStation: record._id
      }),
      // eslint-disable-next-line
      headers: new Headers({'Authorization': localStorage.getItem('token')})
    }

    // eslint-disable-next-line
    fetch(url, options)
      .then(() => {
        this.handleClose()
        showNotification('Pagamento realizado!')
        window.location.reload()
      })
      .catch(() => {
        this.handleClose()
        showNotification('Erro: ocorreu um problema!', 'warning')
        window.location.reload()
      })
  }

  render () {
    const actions = [
      <FlatButton
        primary
        label='Cancelar'
        onClick={this.handleClose}
      />,
      <FlatButton
        primary
        label='Realizar Pagamento'
        onClick={this.handleClick}
      />
    ]

    return (
      <div>
        <FlatButton
          style={style}
          label='Pagamento'
          icon={<AddIcon />}
          onClick={this.handleOpen}
        />
        <Dialog
          modal={false}
          actions={actions}
          title='Digite o valor'
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <TextField id='valueInput' onChange={(e, value) => this.setState({value})} />
        </Dialog>
      </div>
    )
  }
}

CreateMoneyButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
}

export default connect(null, {
  push: pushAction,
  showNotification: showNotificationAction
})(CreateMoneyButton)



// WEBPACK FOOTER //
// ./src/components/createMoneyTransfer.js